module.exports = __webpack_public_path__ + "static/media/prev-test-w.b02ee69a.svg";